import React, { useMemo } from "react";

/* ─── Date helpers (self-contained) ──────────────────────────── */
function startOfDay(d)   { const x = new Date(d); x.setHours(0,0,0,0); return x; }
function startOfWeek(d)  { const x = startOfDay(d); x.setDate(x.getDate() - x.getDay()); return x; }
function startOfMonth(d) { return new Date(d.getFullYear(), d.getMonth(), 1); }
function addDays(d, n)   { const x = new Date(d); x.setDate(x.getDate() + n); return x; }
function addWeeks(d, n)  { return addDays(d, n * 7); }
function addMonths(d, n) { const x = new Date(d); x.setMonth(x.getMonth() + n); return x; }

function fmtDay(d)   {
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}
function fmtWeek(d)  {
  const end = addDays(d, 6);
  return `${d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" })} – ${end.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}`;
}
function fmtMonth(d) {
  return d.toLocaleDateString("en-IN", { month: "long", year: "numeric" });
}

/* ══════════════════════════════════════════════════════════════
   DateNavigator
══════════════════════════════════════════════════════════════ */
export default function DateNavigator({ viewMode, setViewMode, anchor, setAnchor }) {
  const today = new Date();

  const canGoForward = useMemo(() => {
    if (viewMode === "day")   return startOfDay(anchor) < startOfDay(today);
    if (viewMode === "week")  return startOfWeek(anchor) < startOfWeek(today);
    return startOfMonth(anchor) < startOfMonth(today);
  }, [viewMode, anchor]);

  const goBack = () => {
    if (viewMode === "day")   setAnchor(a => addDays(a, -1));
    if (viewMode === "week")  setAnchor(a => addWeeks(a, -1));
    if (viewMode === "month") setAnchor(a => addMonths(a, -1));
  };

  const goFwd = () => {
    if (!canGoForward) return;
    if (viewMode === "day")   setAnchor(a => addDays(a, 1));
    if (viewMode === "week")  setAnchor(a => addWeeks(a, 1));
    if (viewMode === "month") setAnchor(a => addMonths(a, 1));
  };

  const goToday = () => setAnchor(new Date());

  const label = viewMode === "day"
    ? fmtDay(anchor)
    : viewMode === "week"
    ? fmtWeek(startOfWeek(anchor))
    : fmtMonth(startOfMonth(anchor));

  return (
    <div className="dv-date-nav">
      {/* View mode pills */}
      <div className="dv-view-pills">
        {["day", "week", "month"].map(m => (
          <button
            key={m}
            className={`dv-view-pill ${viewMode === m ? "active" : ""}`}
            onClick={() => setViewMode(m)}
          >
            {m.charAt(0).toUpperCase() + m.slice(1)}
          </button>
        ))}
      </div>

      {/* Date stepper */}
      <div className="dv-date-stepper">
        <button className="dv-nav-arrow" onClick={goBack}>‹</button>
        <div className="dv-date-label">{label}</div>
        <button className="dv-nav-arrow" onClick={goFwd} disabled={!canGoForward}>›</button>
      </div>

      {/* Today shortcut */}
      <button className="dv-today-btn" onClick={goToday}>Today</button>
    </div>
  );
}